<template>
  <div class="content-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-12">
          <!-- Recent Order Table -->
          <div class="card card-table-border-none" id="recent-orders">
            <div class="card-header justify-content-between">
              <h2>{{ $t("sidebar.myProductsInSales") }}</h2>
            </div>
            <div class="card-body card-body-white pt-0 pb-5">
              <table
                class="table card-table table-responsive table-responsive-large table-striped width-100"
              >
                <thead>
                  <th class="d-md-table-cell text-center">
                    {{ $t("ecommerce.product.name") }}
                  </th>
                  <th class="d-md-table-cell d-none text-center">
                    {{ $t("attr.pictures") }}
                  </th>
                  <th class="d-md-table-cell d-none text-center">
                    {{ $t("ecommerce.product.quantity") }}
                  </th>
                  <th class="d-md-table-cell d-none text-center">
                    {{ $t("sentence.timeLeft") }}
                  </th>
                  <th class="d-md-table-cell d-none text-center">
                    {{ $t("ecommerce.product.price") }}
                  </th>
                  <th class="d-md-table-cell d-none text-center">
                    {{ $t("sentence.highestOffer") }}
                  </th>
                  <th class="d-md-table-cell d-none text-center">
                    {{ $t("sentence.highestBids") }}
                  </th>
                  <th class="d-md-table-cell text-center">
                    {{ $t("main.action") }}
                  </th>
                </thead>
                <tbody>
                  <tr v-for="product in products" :key="product.id">
                    <td class="d-md-table-cell text-center">
                      <a class="text-dark" href=""> {{ product.name }}</a>
                    </td>
                    <td class="d-md-table-cell d-none text-center">
                      <img
                        :src="
                          Array.isArray(product.pictures)
                            ? storageUrl + product.pictures[0]
                            : storageUrl + product.pictures
                        "
                        class="thumbnail"
                      />
                    </td>
                    <td class="d-md-table-cell d-none text-center">
                      {{ product.quantity }}
                    </td>
                    <td
                      v-if="product.sales_type == 'auction'"
                      class="d-md-table-cell d-none text-center"
                    >
                      <TimerSimple
                        :deadline="product.validated"
                        :duration="product.duration"
                      />
                    </td>
                    <td class="d-md-table-cell d-none text-center" v-else>
                      {{ $t("sentence.noDeadline") }}
                    </td>
                    <td
                      class="d-md-table-cell d-none"
                      v-if="product.sales_type == 'auction'"
                    >
                      {{ $t("ecommerce.product.startingFrom") }}
                      {{
                        product.starting_price
                          | currency(" DA", 0, { symbolOnLeft: false })
                      }}
                    </td>
                    <td classs="d-md-table-cell d-none" v-else>
                      {{
                        product.fixed_price
                          | currency(" DA", 0, { symbolOnLeft: false })
                      }}
                    </td>
                    <td class="d-md-table-cell d-none text-center">
                      <a
                        v-if="product.offers.length > 0"
                        href="#"
                        class="btn btn-outline-default"
                      >
                        {{
                          product.offers[product.offers.length - 1].price
                            | currency(" DA", 0, { symbolOnLeft: false })
                        }}
                      </a>
                      <span v-else>{{
                        $t("sentence.noActionForThisProduct", {
                          action: $t("ecommerce.offers"),
                        })
                      }}</span>
                    </td>
                    <td
                      v-if="product.sales_type == 'auction'"
                      class="d-md-table-cell d-none text-center"
                    >
                      <a
                        v-if="product.bids.length > 0"
                        href="#"
                        class="btn btn-outline-default"
                      >
                        {{
                          product.bids[product.bids.length - 1].price
                            | currency(" DA", 0, { symbolOnLeft: false })
                        }}
                      </a>
                      <span v-else>{{
                        $t("sentence.noActionForThisProduct", {
                          action: $t("ecommerce.bids"),
                        })
                      }}</span>
                    </td>
                    <td class="d-md-table-cell d-none text-center" v-else>-</td>
                    <td class="d-md-table-cell text-center">
                      <router-link
                        :to="{
                          name: 'resellProduct',
                          params: { id: product.id },
                        }"
                        class="btn btn-outline-default"
                      >
                        {{ $t("sentence.relistProduct") }}
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimerSimple from "@/components/templates/TimerSimple";
import config from "@/config";

export default {
  mounted() {
    this.getUserNonSoldProducts();
  },
  components: {
    TimerSimple,
  },
  data() {
    return {
      products: [],
      success: false,
      storageUrl: config.storageUrl,
    };
  },
  methods: {
    getUserNonSoldProducts() {
      var self = this;
      this.$axios({
        url: "user/product/nonSoldProduct",
        method: "GET",
      })
        .then((response) => {
          self.products = response.data;
        })
        .catch(function(err) {
          console.log(err.response.data);
        });
    },
  },
};
</script>

<style scoped>
.thumbnail {
  border: 1px solid var(--color-d); /* Gray border */
  border-radius: 4px; /* Rounded border */
  padding: 5px; /* Some padding */
  width: 150px; /* Set a small width */
}

/* Add a hover effect (blue shadow) */
.thumbnail:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
}

.countdownv2_holder {
  bottom: 50% !important;
}

.countdownv2_holder .countdownv2 {
  width: 100% !important;
}

.card-white {
  background-color: white !important;
}

.card-body-white {
  background-color: white !important;
}

.pagination {
  display: flex;
  justify-content: center;
}
.color-green {
  color: green;
}

.color-red {
  color: red;
}
</style>
